<div class="modal-content">
	<div class="modal-header">
		<h6 class="circularBold signUpHeading">Update Manufacturers</h6>
		<button
            type="button"
            class="close"
            aria-label="Close"
            data-dismiss="modal"
            (click)= "bsModalRef.hide()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
	</div>
	<div class="modal-body">
		<form  [formGroup]="manufacturersForm" >
			<div class="mt-4">
          <label for="exampleFormControlTextarea1" class="form-label">{{"Manufacturers" |  translate}}</label>
          <div class="mb-3" style="max-height: 200px; overflow:auto;">
              <div *ngFor="let item of manufacturers$ | async">
                  
                <input class="form-check-input mb-2" #checkbox type="checkbox" [attr.id]="item.id" [attr.name]="item.name"
                [value]="item.id" 
                (change)="manufacturesChange(item.id)"
                [checked]="userCheck(item.id)"
                >
                <label class="form-check-label ms-1" [attr.for]="item.id">{{item.name}} </label>
                  
              </div>
              
          
          </div>
        
      <button class="btn btn-primary d-block w-100" type="submit" (click)="editmanufacturers()">
        <div *ngIf="!(loading$|async)">
            {{"Save" | translate}}
        </div>
        <div *ngIf="loading$|async">
            <div  class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>    
      </button>

			</div>
		</form>
	</div>
</div>